const endodontics = {
  hero: {
    badgeIconAlt: "Endodontics Icon",
    badgeText: "Προηγμένες Θεραπείες Απονεύρωσης",
    titleLine1: "Σύγχρονη Ενδοδοντική",
    titleLine2: "Φροντίδα & Θεραπεία",
    description:
      "Οι εξειδικευμένες ενδοδοντικές θεραπείες μας διατηρούν τα φυσικά σας δόντια μέσω προηγμένων, ελάχιστα επώδυνων απονευρώσεων, με χρήση της πιο σύγχρονης τεχνολογίας και τεχνικών.",
    ctas: {
      primary: "Κλείστε Ραντεβού",
      secondary: "Μάθετε για τη Διαδικασία",
    },
    heroImageAlt: "Σύγχρονη Ενδοδοντική Θεραπεία",
    stats: {
      successRateLabel: "Ποσοστό Επιτυχίας",
      successRateValue: "95%+",
      painFreeLabel: "Ανώδυνη",
      painFreeValue: "Προηγμένη Τεχνολογία",
    },
    experience: {
      label: "Εξειδικευμένοι Επαγγελματίες",
      value: "15+ Χρόνια Εμπειρίας",
    },
  },
  benefits: {
    heading: "ΓΙΑΤΙ ΝΑ ΕΠΙΛΕΞΕΤΕ ΕΝΔΟΔΟΝΤΙΚΗ ΘΕΡΑΠΕΙΑ",
    intro:
      "Η σύγχρονη θεραπεία απονεύρωσης διατηρεί τα φυσικά σας δόντια με άνεση και ακρίβεια.",
    items: [
      {
        title: "Διατηρήστε τα Φυσικά σας Δόντια",
        description:
          "Η ενδοδοντική θεραπεία σας βοηθά να διατηρήσετε το φυσικό σας χαμόγελο, να συνεχίσετε να απολαμβάνετε τα αγαπημένα σας φαγητά και να μειώσετε την ανάγκη για περαιτέρω οδοντιατρικές εργασίες.",
      },
      {
        title: "Σχεδόν Ανώδυνη",
        description:
          "Χάρη στις σύγχρονες τεχνικές μας, οι ασθενείς αναφέρουν ότι η απονεύρωση είναι τόσο άνετη όσο και ένα απλό σφράγισμα.",
      },
      {
        title: "Αποτελεσματική & Γρήγορη",
        description:
          "Οι ενδοδοντικές θεραπείες μας ολοκληρώνονται σε μόλις 1-2 ραντεβού, προσφέροντας άμεση ανακούφιση από τον πόνο με εξαιρετικά μακροπρόθεσμα αποτελέσματα.",
      },
    ],
  },
  process: {
    heading: "Η ΔΙΑΔΙΚΑΣΙΑ ΤΗΣ ΘΕΡΑΠΕΙΑΣ ΜΑΣ",
    intro:
      "Ακολουθούμε μια ακριβή και μεθοδική προσέγγιση για να εξασφαλίσουμε τα καλύτερα δυνατά αποτελέσματα στις ενδοδοντικές θεραπείες μας.",
    steps: [
      {
        title: "Διάγνωση & Εξέταση",
        description:
          "Οι ειδικοί μας πραγματοποιούν ψηφιακές ακτινογραφίες και εξετάσεις για να εντοπίσουν την πηγή του πόνου και να καθορίσουν εάν απαιτείται ενδοδοντική θεραπεία.",
      },
      {
        title: "Προετοιμασία & Αναισθησία",
        description:
          "Χορηγούμε τοπική αναισθησία ώστε να μουδιάσει πλήρως η περιοχή, διασφαλίζοντας ότι δεν θα αισθανθείτε καθόλου πόνο κατά τη διάρκεια της διαδικασίας.",
      },
      {
        title: "Αφαίρεση Πολφού & Καθαρισμός",
        description:
          "Ο μολυσμένος πολφός αφαιρείται προσεκτικά και οι ριζικοί σωλήνες καθαρίζονται και διαμορφώνονται σχολαστικά με εξειδικευμένα εργαλεία.",
      },
      {
        title: "Έμφραξη & Σφράγιση των Ριζικών Σωλήνων",
        description:
          "Οι καθαρισμένοι σωλήνες γεμίζονται με βιοσυμβατό υλικό και σφραγίζονται για να αποτραπεί η επανεμφάνιση μόλυνσης.",
      },
      {
        title: "Τελική Αποκατάσταση",
        description:
          "Τοποθετείται μία θήκη ή άλλη αποκατάσταση για να προστατευτεί το δόντι και να αποκατασταθεί πλήρως η λειτουργικότητα και η αισθητική του.",
      },
    ],
  },
  faq: {
    heading: "ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ",
    intro:
      "Βρείτε απαντήσεις σε συχνές ερωτήσεις σχετικά με τις ενδοδοντικές θεραπείες",
    items: [
      {
        question: "Είναι επώδυνη η απονεύρωση;",
        answer:
          "Με τις σύγχρονες τεχνικές και την αναισθησία, η απονεύρωση μοιάζει με ένα απλό σφράγισμα. Οι περισσότεροι ασθενείς αισθάνονται άνετα κατά τη διάρκεια της διαδικασίας και αναφέρουν μόνο ήπια ενόχληση μετά, η οποία αντιμετωπίζεται εύκολα με παυσίπονα χωρίς ιατρική συνταγή.",
      },
      {
        question: "Πόσο διαρκεί μια απονεύρωση;",
        answer:
          "Οι περισσότερες απονευρώσεις ολοκληρώνονται σε ένα ραντεβού που διαρκεί 60-90 λεπτά. Πιο περίπλοκες περιπτώσεις μπορεί να χρειαστούν δύο επισκέψεις. Η χρήση προηγμένης τεχνολογίας διασφαλίζει την αποτελεσματικότητα χωρίς να θυσιάζεται η ποιότητα.",
      },
      {
        question: "Πόσο καιρό διαρκεί ένα δόντι μετά από απονεύρωση;",
        answer:
          "Με τη σωστή φροντίδα, ένα δόντι που έχει υποβληθεί σε απονεύρωση μπορεί να διαρκέσει μια ζωή. Το ποσοστό επιτυχίας είναι πολύ υψηλό και τα περισσότερα δόντια που έχουν απονευρωθεί διατηρούνται το ίδιο καλά όσο και τα φυσικά.",
      },
      {
        question: "Τι θα συμβεί αν δεν κάνω απονεύρωση;",
        answer:
          "Αν χρειάζεστε απονεύρωση και δεν την κάνετε, η μόλυνση θα συνεχίσει να εξαπλώνεται, προκαλώντας πιθανώς απόστημα, απώλεια οστού και τελικά απώλεια του δοντιού. Η μόλυνση μπορεί επίσης να εξαπλωθεί και σε άλλα σημεία του σώματος, προκαλώντας σοβαρούς κινδύνους για την υγεία.",
      },
      {
        question: "Χρειάζομαι οδοντική κορώνα μετά από απονεύρωση;",
        answer:
          "Στις περισσότερες περιπτώσεις, ναι. Η οδοντική κορώνα προστατεύει το θεραπευμένο δόντι από σπασίματα και επαναφέρει πλήρως τη λειτουργικότητά του. Τα πίσω δόντια (γομφίοι και προγόμφιοι) χρειάζονται σχεδόν πάντα κορώνα, ενώ τα μπροστινά δόντια μπορεί να μην χρειάζονται εάν είναι δομικά υγιή.",
      },
      {
        question: "Πώς να φροντίσω το δόντι μου μετά από απονεύρωση;",
        answer:
          "Αφού τοποθετηθεί η τελική αποκατάσταση, πρέπει να φροντίζετε το δόντι σας όπως και τα φυσικά δόντια: βουρτσίστε δύο φορές την ημέρα, χρησιμοποιήστε οδοντικό νήμα καθημερινά, στοματικό διάλυμα με αντιμικροβιακή δράση και επισκέπτεστε τακτικά τον οδοντίατρο για ελέγχους και καθαρισμούς.",
      },
    ],
  },
};

export default endodontics;

